
export const EXCEPTION_NEWS_CATEGORIES = {
    'accelerator-enabler': 'Accelerator/Enabler',
    'acquisition-exit': 'Acquisition/Exit',
    'conferences-and-events': 'Conferences & Events',
    'interview-q-and-a': 'Interview/Q&A',
    'vc-angel-investment': 'VC/Angel Investment'
};

const popularCategories = {
    'development': [
        { id: 314, name: 'MAGNiTT', icon: 'fas fa-rocket', selected: false},
        { id: 2085, name: 'Funding', icon: 'fas fa-money-check-alt', selected: false},
        { id: 5312, name: 'Acquisition/Exit', icon: 'fas fa-door-open', selected: false},
        { id: 6779, name: 'Thought Piece', icon: 'fas fa-lightbulb', selected: false},
        { id: 6773, name: 'Accelerator/Enabler', icon: 'fas fa-tachometer-alt', selected: false},
        { id: 6778, name: 'Data Insight', icon: 'fas fa-brain', selected: false},
        { id: 6776, name: 'Startup Update', icon: 'fas fa-info', selected: false},
        { id: 328, name: 'Press Release', icon: 'fas fa-newspaper', selected: false},
        { id: 6780, name: 'Government Initiative', icon: 'fas fa-suitcase', selected: false},
        { id: 6774, name: 'Interview/Q&A', icon: 'fas fa-question', selected: false},
        { id: 6775, name: 'VC/Angel Investment', icon: 'fas fa-funnel-dollar', selected: false},
        { id: 6777, name: 'Webinar', icon: 'fas fa-chalkboard', selected: false}
    ],
    'production': [
        { id: 314, name: 'MAGNiTT', icon: 'fas fa-rocket', selected: false},
        { id: 2085, name: 'Funding', icon: 'fas fa-money-check-alt', selected: false},
        { id: 5312, name: 'Acquisition/Exit', icon: 'fas fa-door-open', selected: false},
        { id: 6731, name: 'Thought Piece', icon: 'fas fa-lightbulb', selected: false},
        { id: 6735, name: 'Accelerator/Enabler', icon: 'fas fa-tachometer-alt', selected: false},
        { id: 6732, name: 'Data Insight', icon: 'fas fa-brain', selected: false},
        { id: 6738, name: 'Startup Update', icon: 'fas fa-info', selected: false},
        { id: 328, name: 'Press Release', icon: 'fas fa-newspaper', selected: false},
        { id: 6733, name: 'Government Initiative', icon: 'fas fa-suitcase', selected: false},
        { id: 6736, name: 'Interview/Q&A', icon: 'fas fa-question', selected: false},
        { id: 6737, name: 'VC/Angel Investment', icon: 'fas fa-funnel-dollar', selected: false},
        { id: 6743, name: 'Webinar', icon: 'fas fa-chalkboard', selected: false}
    ]
}

export const NEWS_POPULAR_CATEGORIES = popularCategories[process.env.NODE_ENV];

const popularCategoriesIds = {
    'development': [314, 2085, 5312, 6779, 6773, 6778, 6776, 328, 6780, 6774, 6775, 6777],
    'production': [314, 2085, 5312, 6731, 6735, 6732, 6738, 328, 6733, 6736, 6737, 6743]
};

export const NEWS_POPULAR_CATEGORIES_IDS = popularCategoriesIds[process.env.NODE_ENV];

const newsDataInsightId = {
    'development': 6778,
    'production': 6732
};

export const NEWS_DATA_INSIGHTS_ID = newsDataInsightId[process.env.NODE_ENV];